<p-table #dt [columns]="cols" [value]="dados" [rowHover]="true" [loading]="loading" [scrollable]="true"
  scrollHeight="50vh" [autoLayout]="true"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
  sortMode="multiple" [globalFilterFields]="['codDealer']" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup *ngFor="let col of columns">
      <col [style]="col.width">
    </colgroup>
  </ng-template>

  <ng-template #message pTemplate="emptymessage" let-columns>
    <tr *ngIf="dados?.length != 0">
      <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
        style="padding: 20px;">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="2"
      class="frozenColumn">
        Land Rover
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Abr / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Mai / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Jun / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Q1 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Jul / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Ago / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Set / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Q2 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Out / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Nov / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Dez / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Q3 / {{totaisHistorico.filtroAno}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Jan / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Fev / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Mar / {{totaisHistorico.filtroAno + 1}}
      </th>
      <th style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);" colspan="5">
        Q4 / {{totaisHistorico.filtroAno + 1}}
      </th>
    </tr>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th [pSortableColumn]="col.field" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
          [ngStyle]="{'width': col.width}"
          [class.frozenColumnDealer]="col.field == 'codDealer'" [class.frozenColumnNome]="col.field == 'nomeDealer'" >
          {{col.header}}
          <p-sortIcon [field]="col.field" class="p-sortable-colum"
            *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
          </p-sortIcon>
        </th>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-dados let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [class.frozenColumnInfoDealer]="col.field == 'codDealer'"
      [class.frozenColumnInfoNome]="col.field == 'nomeDealer'">
        <div *ngIf="col.field != 'visivel'">
          <ng-container *ngIf="col.field.includes('Percent'); else checkMonetary">
            {{ dados[col.field] | number:'1.2-2':'pt-BR' }}%
          </ng-container>
          <ng-template #checkMonetary>
            <ng-container *ngIf="col.field.includes('ObjSpnv') || col.field.includes('VendaAcessorio') || col.field.includes('SpnvRealizado') || col.field.includes('VeiculosVista'); else normalValue">
              {{ dados[col.field] | number:'1.2-2':'pt-BR' }}
            </ng-container>
            <ng-template #normalValue>
              {{ dados[col.field] }}
            </ng-template>
          </ng-template>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer" let-dados let-columns="columns">
    <tr>
      <td class="text-center frozenColumn" style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
        colspan="2">
        Brasil
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAbrPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMaiPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJunPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1ObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1VeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1VendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1SpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ1Percent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJulPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalAgoPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalSetPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2ObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2VeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2VendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2SpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ2Percent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalOutPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalNovPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalDezPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3ObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3VeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3VendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3SpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ3Percent}}% 
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalJanPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFev2ObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalFevPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarVeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarVendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarSpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalMarPercent}}%
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4ObjSpnv | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4VeiculosVista | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4VendaAcessorio | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4SpnvRealizado | number:'1.2-2':'pt-BR'}}
      </td>
      <td style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
        {{totaisHistorico.totalQ4Percent}}%
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="card" *ngIf="dados?.length === 0">
  <div class="card-body bg-no-records p-shadow-3">
    <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
  </div>
</div>
